import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ENVIRONMENT_PROVIDER } from '@mkp/shared/util-environment';
import { ResourceService } from '@mkp/shared/data-access';
import { VacancySerializer } from '@mkp/vacancy/data-access';
import { Vacancy, VacancyVideosDto } from '@mkp/vacancy/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class VacancyService extends ResourceService<Vacancy & VacancyVideosDto> {
  constructor() {
    const http = inject(HttpClient);
    const environment = inject(ENVIRONMENT_PROVIDER);

    super(http, environment.api.core, 'vacancy', VacancySerializer);
  }

  createVacancy(vacancy: Vacancy): Observable<Vacancy & VacancyVideosDto> {
    const body = VacancySerializer.toJson(vacancy);
    return this.httpClient
      .post<Vacancy & VacancyVideosDto>(`${this.url}/${this.endpoint}`, body)
      .pipe(
        map(
          (data) =>
            VacancySerializer.fromJson(
              data as Parameters<typeof VacancySerializer.fromJson>[0]
            ) as Vacancy & VacancyVideosDto
        )
      );
  }

  updateVacancy(vacancy: Vacancy): Observable<Vacancy & VacancyVideosDto> {
    const body = VacancySerializer.toJson(vacancy);
    return this.patchValue<Vacancy & VacancyVideosDto>(body, { maxRetry: 1 });
  }
}
